import DataTable from "../datatable/DataTable";

export const List = ({ title, text = "", table, actions = [], bulkActions = [], page, setPage, limit, setLimit, total, onColumnFilterChange, columnFilters,
  setColumnFilters, initialVisibleColumns = [], loading, setDataInicio = null, dataInicio = null, setDataFim = null, dataFim = null, handleFilterData = null, 
  setShowModal = null, showModal = null, getRowStyle = null, getRowClassName = null, legend = null, renderExpandedRow = null, getRowId = null,
  enableRowSelection = true, expandOnDoubleClick = false, expandWithIndicatorOnly = false }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "90vw",
        margin: "auto",
        marginTop: "clamp(3rem, 10vh, 6rem)",
        gap: "10px",
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      <DataTable
        title={title}
        text={text}
        data={table.data}
        columns={table.columns}
        actions={actions}
        bulkActions={bulkActions}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        total={total}
        onColumnFilterChange={onColumnFilterChange}
        columnFilters={columnFilters}
        setColumnFilters={setColumnFilters}
        initialVisibleColumns={initialVisibleColumns}
        setDataInicio={setDataInicio}
        dataInicio={dataInicio}
        setDataFim={setDataFim}
        dataFim={dataFim}
        handleFilterData={handleFilterData}
        setShowModal={setShowModal}
        showModal={showModal}
        loading={loading}
        legend={legend}
        getRowStyle={getRowStyle}
        getRowClassName={getRowClassName}
        renderExpandedRow={renderExpandedRow}
        getRowId={getRowId}
        enableRowSelection={enableRowSelection}
        expandOnDoubleClick={expandOnDoubleClick}
        expandWithIndicatorOnly={expandWithIndicatorOnly}
      />
    </div>
  );
};
